
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CTASection() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    
    setIsSubmitting(true);
    setSubmitStatus('');
    
    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('subscription_type', 'newsletter');
      
      const response = await fetch('https://readdy.ai/api/form/d3737uh8vlfrnhb0cq60', {
        method: 'POST',
        body: new URLSearchParams(formData as any)
      });
      
      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMembershipSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const formData = new FormData();
      formData.append('membership_type', 'general');
      formData.append('interest_area', 'general_membership');
      
      const response = await fetch('https://readdy.ai/api/form/d3737uh8vlfrnhb0cq5g', {
        method: 'POST',
        body: new URLSearchParams(formData as any)
      });
      
      if (response.ok) {
        alert('Thank you for your interest! We will contact you soon with membership information.');
      }
    } catch (error) {
      alert('There was an error processing your request. Please try again.');
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-800 text-white relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/d284417f0249edc6f99ab124f2ddf519.jpg')`
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-blue-800/80"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Join the Canadian Pharmacy & Veterinary Association Today
        </h2>
        <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto">
          Be part of a movement that's transforming healthcare through collaboration, innovation, and shared commitment to better outcomes for all.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <form onSubmit={handleMembershipSubmit} data-readdy-form="membership_application">
            <Button 
              size="lg" 
              type="submit"
              className="bg-red-600 hover:bg-red-700 text-lg px-10 py-4"
            >
              Join Now
            </Button>
          </form>
          <Button 
            variant="outline" 
            size="lg"
            className="border-white text-white hover:bg-white hover:text-blue-900 text-lg px-10 py-4"
            onClick={() => navigate('/membership')}
          >
            Learn More
          </Button>
        </div>
        
        <div className="max-w-md mx-auto">
          <h3 className="text-xl font-semibold mb-4">Stay Updated</h3>
          <form onSubmit={handleNewsletterSubmit} className="flex gap-3" data-readdy-form="newsletter_subscription">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-white"
              required
              maxLength={500}
            />
            <Button 
              type="submit" 
              disabled={isSubmitting}
              className="bg-white text-blue-900 hover:bg-gray-100 px-6"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
            </Button>
          </form>
          {submitStatus === 'success' && (
            <p className="text-green-300 text-sm mt-2">Successfully subscribed to our newsletter!</p>
          )}
          {submitStatus === 'error' && (
            <p className="text-red-300 text-sm mt-2">There was an error. Please try again.</p>
          )}
        </div>
      </div>
    </section>
  );
}
